import type { TFunction } from 'i18next';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ISelectOption } from '@feathr/components';
import { UniversalSelect } from '@feathr/components';

import * as styles from './DonationFormEngagementCard.css';

export enum EDonationEngagementFlavor {
  Viewed = 'viewed',
  ViewedNoDonation = 'viewed_no_donation',
  OneTime = 'one_time',
  Recurring = 'recurring',
}

export const donationEngagementFlavorLabel = (
  t: TFunction,
): Record<EDonationEngagementFlavor, string> => ({
  [EDonationEngagementFlavor.Viewed]: t('Viewed form'),
  [EDonationEngagementFlavor.ViewedNoDonation]: t('Viewed, no donation'),
  [EDonationEngagementFlavor.OneTime]: t('One-time donations'),
  [EDonationEngagementFlavor.Recurring]: t('Recurring donations'),
});

interface IProps {
  flavor: EDonationEngagementFlavor;
  onSelectSingle: ((value: { id: string; name: string }) => void) | undefined;
}

function DonationFormInteractionSelect({ flavor, onSelectSingle }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  const flavors = [
    EDonationEngagementFlavor.Viewed,
    EDonationEngagementFlavor.ViewedNoDonation,
    EDonationEngagementFlavor.OneTime,
    EDonationEngagementFlavor.Recurring,
  ];

  function mapFlavorToOption(value: EDonationEngagementFlavor): ISelectOption {
    return { id: value, name: donationEngagementFlavorLabel(t)[value] };
  }

  const options = flavors.map(mapFlavorToOption);

  return (
    <UniversalSelect
      label={t('Interaction')}
      name={'donation-interaction'}
      onSelectSingle={onSelectSingle}
      options={options}
      value={options.find(({ id }) => id === flavor) ?? options[0]}
      wrapperClassName={styles.select}
    />
  );
}

export default observer(DonationFormInteractionSelect);
